<template>
  <b-container>
    <b-breadcrumb :items="items" @click="navigate"></b-breadcrumb>
    <!-- <b-form-group label="Select Report Category" label-size="sm"> -->
    <b-row>
      <b-col md="3">
        <b-form-group
          id="exampleInputGroup2"
          label="Report Category"
          label-size="sm"
          label-for="radiosg"
        >
          <b-form-radio-group
            id="ragiosg"
            v-model="selected"
            :options="MainList"
            value-field="CategoryID"
            text-field="Category"
            class="mb-3"
            disabled-field="notEnabled"
            @change.native="onChange"
            stacked
            size="sm"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
      <!-- </b-form-group> -->
      <b-col md="8">
        <div class="row">
          <b-col>
            <b-form-group
              id="grp1"
              label-cols="2"
              label="Report Name:"
              label-size="sm"
              label-for="ipReport"
              v-if="show"
            >
              <b-select
                id="ipReport"
                value-field="ReportID"
                size="sm"
                text-field="ReportName"
                :options="subarray"
                v-model="output.ReportID"
                @change.native="onReportChange"
              ></b-select>
            </b-form-group>
          </b-col>
          <!-- <div class="form-group col-md-12" style="padding:0" v-if="show">
            <label for="inputUser3" style="margin-top:5px" class="col-sm-2">Report Name</label>
            <div class="col-sm-9">
              <select
                v-model="output.ReportID"
                class="form-control toli_id"
                data-placeholder
                tabindex="1"
                id="bank"
                name="bank"
                @change="onReportChange"
                style="border-radius:5px"
              >
                <option
                  v-for="(arrid, index) in subarray"
                  :value="arrid.ReportID"
                  :key="index"
                >{{arrid.ReportName}}</option>
              </select>
            </div>
          </div>-->
        </div>
        <hr v-if="show" />
        <b-row>
          <b-col md="12">
            <form-generator :schema="schema" v-if="show" v-model="formData"></form-generator>
          </b-col>
        </b-row>
        <div class="row">
          <div class="col-md-12">
            <b-btn
              variant="success"
              size="sm"
              text="View Report"
              @click="showReport"
              style="float:right"
              v-if="show"
            >View Report</b-btn>
            <b-btn
              variant="secondary"
              size="sm"
              text="View Report"
              @click="reset"
              style="float:right"
              class="mx-3"
              v-if="show"
            >Reset</b-btn>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Vue from "vue";
import * as _ from "lodash";
import FormGenerator from "@/components/Generator/FormGenerator";
import DatePicker from "vue2-datepicker";
import axios from "axios";
//import "vue2-datepicker/index.scss";
const base_url = process.env.VUE_APP_BASE_URL;
export default {
  props: ["mainCategory"],
  components: { FormGenerator, DatePicker },
  data() {
    return {
      show: false,
      selected: "",
      selectedReport: "",
      items: [],
      schema: [],
      formData: {},
      output: {
        BoardID: 1,
        ReportID: 0,
        ReportFilter: {}
      },
      fields: [],
      itemsTemplate: [
        {
          text: "All",
          href: "#",
          cat: 0
        }
      ],
      MainList: [],
      MainListTemplate: [],
      subarray: [],
      SubList: [],
      CategoryID: "",
      SubList: []
    };
  },
  mounted() {
    this.get_mainList();
    // this.MainList = this.MainListTemplate.Category;
  },
  methods: {
    get_mainList() {
      this.items = JSON.parse(JSON.stringify(this.itemsTemplate));
      this.get_child_list(this.mainCategory);
    },
    get_child_list: function(val) {
      let promise = apis.GetReportCategory({ CategoryID: val });
      promise
        .then(response => {
          if (response.status == 200) {
            let obj = response.data;
            if (obj) {
              this.MainList = obj;
            }
          }
        })
        .catch(err => {
          console.error(err);
          alert("ERROR");
        });
    },
    get_report_list(val) {
      let promise = apis.GetReportMaster({ CategoryID: val });

      promise
        .then(response => {
          if (response.status == 200) {
            let obj = response.data;
            if (obj) {
              this.subarray = obj;
              this.subarray.splice(0, 0, { ReportID: 0, ReportName: "Select" });
              this.output.ReportID = 0;
            } else {
              this.subarray = [];
            }
          }
        })
        .catch(err => {
          console.error(err);
          alert("ERROR");
        });
    },
    get_schema(val, typ) {
      this.output.ReportFilter = {};
      this.schema = [];
      this.formData={};
      let promise;
      if (typ == "category") {
        //promise = apis.get_report_schema({ CategoryID: val });
        return;
      } else {
        promise = apis.GetReportParameters({
          CategoryID: val
        });
      }

      promise
        .then(response => {
          if (response.status == 200) {
            let obj = response.body;
            if (obj) {
              for (var i = 0; i < obj.length; i++) {
                if (
                  obj[i].fieldType == "SelectList" &&
                  obj[i].selectOptionsAPI != null
                ) {
                  obj[i].options = this.$store.getters.getDynamicValues(
                    obj[i].selectOptionsAPI
                  );
                  //we are not passing API link in the schema; we are refferring to objects in the store
                } else if (obj[i].fieldType == "SelectList") {
                  obj[i].options = JSON.parse(obj[i].selectOptions);
                }
                this.schema.push(obj[i]);
              }
            }
          }
        })
        .catch(err => {
          console.log("Error", err);
          alert("ERROR");
        });
    },
    reset(evt) {
      evt.preventDefault();
      //let tempschema = this.selectedReport;
      this.formData={};
      
      // for (var x in this.formData) {
      //   this.formData[x] = null;
      // }
      this.schema = [];
      this.output.ReportFilter = {};
      //this.get_schema(this.selected, "category");
      this.get_schema(this.output.ReportID, "report");
    },
    showReport(evt) {
      evt.preventDefault();
      //this.$router.push("/report");
      let reportName = _.filter(this.subarray, {
        ReportID: this.output.ReportID
      })[0].ReportName;

      // this.output.having_para = [];
      // this.output.where_para = [];
      // for (let x in this.formData) {
      //   let key = x;
      //   let val = this.formData[x];
      //   let obj = _.filter(this.schema, { name: key })[0];
      //   if (obj.HavingFlag) {
      //     this.output.having_para.push({
      //       field_name: obj.db_field,
      //       condition: obj.compareSign, //between, in, <>, >, <
      //       value: val,
      //       start_value: "",
      //       end_value: "",
      //       arrayValue: [],
      //       table_name: obj.table_name,
      //       replace_alias: obj.replace_alias,
      //       id: obj.CategoryFilterID
      //     });
      //   } else {
      //     this.output.where_para.push({
      //       field_name: obj.db_field,
      //       condition: obj.compareSign, //between, in, <>, >, <
      //       value: val,
      //       start_value: "",
      //       end_value: "",
      //       arrayValue: [],
      //       table_name: obj.table_name,
      //       replace_alias: obj.replace_alias,
      //       id: obj.CategoryFilterID
      //     });
      //   }
      // }
      this.output.ReportFilter = this.formData;
      
      this.$store.dispatch("setReportQuery", this.output);
      this.$store.dispatch("setReportName", reportName);
      this.$emit("clicked");
    },
    onChange(evt) {
      let val = evt.target.value;
      let obj = _.filter(this.MainList, { CategoryID: parseInt(val) })[0];
      this.schema = [];

      if (obj) {
        if (obj.IsLast) {
          //this.subarray = obj.SubList;
          this.get_report_list(val);
          //this.schema = obj.filterCriteria;
          //this.get_schema(val, "category");
          this.show = true;
        } else {
          this.subarray = [];
          this.items.push({
            text: obj.Category,
            href: "#",
            cat: val
          });
          this.schema = [];
          this.show = false;
          this.get_child_list(val);
        }
      }

      //let obj = _.filter(this.SubList, { MainList: val })[0];
      //console.log(obj);
    },
    onReportChange(evt) {
      evt.preventDefault();

      let val = evt.target.value;
      this.get_schema(val, "report");
    },
    navigate(evt) {
      let val = evt.target.text;
      this.show = false;
      this.subarray = [];
      this.schema = [];
      this.selected = "";
      this.selectedReport = "";

      if (val == "All") {
        //this.items = JSON.parse(JSON.stringify(this.itemsTemplate));
        //this.MainList = JSON.parse(JSON.stringify(this.MainListTemplate));

        this.get_mainList();
      } else {
        let i = _.findIndex(this.items, { text: val });
        this.items.splice(i + 1, this.items.length - (i + 1));

        this.get_child_list(this.items[i].cat);
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ReportViewer/ReportsQuery.vue